<template>
  <div class="logistics-jobs-item">
    <div class="transaction" :class="{'selected': showDetails}" v-ripple>
      <div class="columns is-mobile is-vcentered">
        <div class="column is-narrow ticket" @click="toggleDetails">
          <img :src="icon(t)" />
          <p>{{ shortDateTime(t.data.scheduled_time) }}</p>
        </div>
        <div class="column middle" @click="toggleDetails">
          <div class="has-text-left">
            <p>
              <i class="fa fa-user pad" />
              <span>{{ customerName }}</span>
              <span class="tag state-tag" :class="stateClass(t)">{{ prettyState(t) }}</span>
            </p>
            <p>
              <i class="fa fa-truck pad" />
              <span>{{ driverName }}</span>
            </p>
            <p>
              <i class="fa fa-coins pad" />
              <span class="has-text-weight-medium">{{currency}}{{ farePrice(t) }}</span>
              <span class="tag updated-tag">{{ updatedAt(t) }}</span>
            </p>
          </div>
        </div>
        <div class="column is-1" @click="openOrder(t)">
          <i class="fa fa-chevron-right fa-2x" />
        </div>
      </div>
    </div>
    <collapse-transition>
      <div v-show="showDetails" class="details has-text-left">
        <a class="delete is-medium is-pulled-right" @click="showDetails = false" />
        <p class="job-details">
          {{ $t("logistics.job-details") }}
          <span
            class="tag is-pulled-right"
            style="margin-right:8px"
            @click="transactionUpdatedInfo"
          >{{ $t("updated") }}&nbsp;{{ shortDateTime(t.updated_at) }}</span>
        </p>
        <table class="table is-fullwidth" style="margin-bottom:10px">
          <tbody>
            <tr>
              <td class="is-narrow">{{ $t("customer") }}</td>
              <td @click="callPhoneNumber(t.customer.phone_number)">
                {{ t.customer.phone_number }}
                <span class="tag is-rounded is-info">
                  <i class="fa fa-phone" />
                </span>
              </td>
            </tr>
            <tr>
              <td class="is-narrow">{{ $t("logistics.goods") }}</td>
              <td>{{ t.data.delivery.goods }}</td>
            </tr>
            <tr>
              <td class="is-narrow">{{ $t("logistics.value") }}</td>
              <td>
                <span v-if="orderValue(t)">{{currency}}{{ orderValue(t) }}</span>
              </td>
            </tr>
            <tr>
              <td class="is-narrow">{{ $t("notes") }}</td>
              <td>{{ t.data.delivery.notes }}</td>
            </tr>
            <tr>
              <td class="is-narrow">{{ $t("driver.driver") }}</td>
              <td v-if="t.driver">
                {{ t.driver.phone_number }}
                <span
                  class="tag is-rounded is-success"
                  @click="callPhoneNumber(t.driver.phone_number)"
                >
                  <i class="fa fa-phone" />
                </span>
                <span
                  class="tag is-pulled-right"
                  @click="driverUpdatedInfo"
                >{{ timeAgo(t.driver.user_state.updated_at) }}</span>
              </td>
              <td v-else>
                <span class="tag is-danger">No driver</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="columns is-mobile actions">
          <div class="column">
            <span class="tag is-rounded is-danger" @click="cancelJob">{{ $t("cancel-job") }}</span>
          </div>
          <div class="column">
            <span
              class="tag is-rounded is-primary"
              @click="changeDriver"
            >{{ $t("driver.change-driver") }}</span>
          </div>
          <div class="column">
            <span class="tag is-rounded is-link" @click="shareJob">
              {{ $t("share") }}&nbsp;
              <i class="fa fa-paper-plane" />
            </span>
          </div>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import vehicles from "@/vehicles";
import { sounds } from "../functions.js";

export default {
  name: "LogisticsJobsItem",
  components: {},
  props: {
    t: Object
  },
  data() {
    return {
      showDetails: false
    };
  },
  computed: {
    role() {
      return this.$store.getters.getLogisticsAgentRole;
    },
    workflow() {
      return this.role.workflow;
    },
    currency() {
      return this.currencySymbol(this.role.business.country);
    },
    fleets() {
      return this.$store.getters.getLogisticsAgentFleetWorkflows;
    },
    customerName() {
      if (this.t.customer.name === "") return this.t.customer.phone_number;
      return this.shortenString(this.t.customer.name, 30);
    },
    driverName() {
      if (!this.t.driver) return "None";
      if (this.t.driver.name === "") return this.t.driver.phone_number;
      return this.shortenString(this.t.driver.name, 30);
    }
  },
  mounted() {
    EventBus.$on("LOGISTICS_JOB_ITEM", () => (this.showDetails = false));
  },
  methods: {
    toggleDetails() {
      if (!this.showDetails) {
        EventBus.$emit("LOGISTICS_JOB_ITEM"); // closes other open item if any
        setTimeout(() => this.scrollIntoView(), 300);
      }
      this.showDetails = !this.showDetails;
    },
    scrollIntoView() {
      this.$el.scrollIntoView({ behavior: "smooth" });
    },
    driverUpdatedInfo() {
      var ago = this.timeAgo(this.t.driver.user_state.updated_at);
      this.infoToast(`Driver last updated ${ago}`);
    },
    transactionUpdatedInfo() {
      var ago = this.timeAgo(this.t.updated_at);
      this.infoToast(`Transaction updated ${ago}`);
    },
    shareJob() {
      var shortID = this.t.data.delivery.short_link;
      if (!shortID) return this.errorToast("No shareable link!", "top");
      var url = process.env.VUE_APP_HOST;
      var shortLink = `${url}/q/${shortID}`;
      this.$copyText(shortLink);
      this.infoToast("Share Job, Link Copied", "top"); // copied to clipboard
      if (!navigator.share) {
        var txt = `Sharing not supported by this device.<br><br>Send as SMS or paste into a chat.`;
        return this.warningAlert(txt);
      }
      var msg = this.$t("TUK Logistics📦 Click link to see your order!🎉");
      navigator
        .share({ text: msg, url: shortLink })
        .then(() => console.log("Successful share"))
        .catch(err => console.log("Error sharing", err));
    },
    changeDriver() {
      this.infoToast("Change driver, coming soon!", "top");
    },
    cancelJob() {
      var red = this.bulmaColor("danger");
      this.$swal({
        title: `<i class="fa fa-question fa-2x" style="color:${red}" />`,
        html: `<div style='font-size:1.2em'>${this.$t(
          "logistics.cancel-are-you-sure"
        )}</div>`,
        showCancelButton: true,
        showCloseButton: true,
        cancelButtonText: this.$t("yes-cancel"),
        confirmButtonText: this.$t("no"),
        cancelButtonColor: red
      }).then(val => {
        if (val.dismiss === "cancel") {
          var loader = this.loadingDots();
          this.$store
            .dispatch("patchTransaction", {
              transactionID: this.t.id,
              data: { state: "cancelled_by_agent" }
            })
            .then(() => {
              this.successToast("Job cancelled successfully");
              this.updateOrdersLogisticsAgent();
            })
            .catch(err => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    updatedAt(t) {
      return this.timeAgo(t.updated_at); // mins ago, days ago, etc
    },
    icon(t) {
      var fleet = this.fleets.find(w => w.id === t.workflow_id);
      if (!fleet || !fleet.data.icon) return vehicles.img("Balloon");
      var iconName = fleet.data.icon;
      return vehicles.img(iconName);
    },
    isOld(t) {
      return this.hoursAgo(t.created_at) > 24;
    },
    prettyDate(t) {
      var dt = new Date(t.created_at);
      return dt.toLocaleDateString();
    },
    newOrderStyle(t) {
      var color = this.bulmaColor("warning");
      if (this.secondsAgo(t.created_at) > 180)
        color = this.bulmaColor("danger");
      return `background-color:${color}`;
    },
    openOrder(t) {
      // sounds("navigate1");
      this.gotoDelay("/logistics_order/" + t.id);
    },
    openOrderDetails(t) {
      if (this.isWorking) sounds("navigate1");
      EventBus.$emit("OPEN_ORDER_DETAILS", t);
      this.$nextTick(() => this.displayModal(".order-details-modal"));
    },
    prettyState(t) {
      // if (t.state === "confirmed") return this.$t("ecommerce.being-prepared");
      // if (t.state === "ready") return this.$t("ecommerce.waiting-for-pickup"); // if take-away
      // if (t.state === "completed") return "Completed";
      // if (t.state === "timed_out") return "Expired";
      return t.state;
    },
    stateClass(t) {
      var tagClass = "is-dark";
      if (t.state === "scheduled") tagClass = "is-info";
      if (t.state === "confirmed") tagClass = "is-warning";
      if (t.state === "ready") tagClass = "is-orange";
      if (t.state === "alighted") tagClass = "is-success";
      if (t.state === "timed_out") tagClass = "is-danger";
      return tagClass;
    },
    orderValue(t) {
      return t.data.delivery.order_value; //t.data.order.order_value;
    },
    farePrice(t) {
      return t.data.fare.price;
    }
  }
};
</script>

<style scoped>
.transaction {
  background-color: white;
  position: relative;
  border-radius: 10px;
  border: 1px solid lightgrey;
  box-shadow: 0px 1px 1px lightgrey;
}
.columns {
  margin: 0 8px;
  padding: 4px;
}
.column.is-1 {
  padding: 0 0;
}
.column.middle {
  padding-right: 0;
}
p {
  margin-bottom: 0px !important;
}
.ticket {
  background-color: azure;
  border: 2px dotted grey;
  padding: 4px;
}
.ticket p {
  margin-top: -10px;
  font-size: 0.8em;
  font-weight: 600;
}
.pad {
  width: 16px;
  margin-right: 12px;
}
.pulse {
  padding: 3px;
  border-radius: 50%;
  animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.95);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.05);
  }
}
.is-orange {
  background-color: orange;
}
.debug-info {
  position: fixed;
  bottom: 10px;
  right: 10px;
  box-shadow: 1px 1px 1px grey;
}
/* .none {
  font-size: 1.25rem;
  width: 100%;
} */
.is-narrow img {
  width: 50px;
}
.tag {
  padding: 6px;
}
.state-tag {
  position: absolute;
  right: 10px;
  top: 10px;
  font-weight: 500;
}
.updated-tag {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.details {
  padding: 10px;
  padding-top: 16px;
  z-index: 0;
  border: 1px solid rgba(128, 128, 128, 0.4);
  /* margin: 0 10px; */
  margin-top: -10px;
  border-radius: 10px;
  /* background-color: rgba(77, 255, 0, 0.4); */
  background-color: lightgoldenrodyellow;
}
.table {
  border-radius: 10px;
}
.job-details {
  font-weight: 500;
  padding-bottom: 6px;
}
.selected {
  background-color: lightgoldenrodyellow;
}
.actions {
  margin: 0;
  padding: 0;
}
.actions .column {
  margin: 0;
  padding: 0;
  text-align: center;
}
/* .is-narrow {
  padding-right: 0;
  font-weight: 450;
} */
td.is-narrow {
  padding-right: 0;
  font-weight: 500;
  color: rgb(126, 118, 118);
}
</style>